import { Configuration as MsalConfiguration, RedirectRequest } from '@azure/msal-browser';
import { getI18n } from 'react-i18next';

const clientId = import.meta.env.VITE_AZURE_AD_B2C_CLIENT_ID;
const tenantId = import.meta.env.VITE_AZURE_AD_B2C_TENANT_ID;
const authority = import.meta.env.VITE_AZURE_AD_B2C_AUTHORITY;
const scopesAuthority = import.meta.env.VITE_AZURE_AD_B2C_SCOPES_AUTHORITY;
const defaultUserFlow = import.meta.env.VITE_AZURE_AD_B2C_DEFAULT_USER_FLOW;
const defaultPlatform = import.meta.env.VITE_AZURE_AD_B2C_DEFAULT_PLATFORM;

const getAuthority = (userFlow: string) => `https://${authority}/${tenantId}/${userFlow}`;

export const AuthConfig: MsalConfiguration = {
  auth: {
    clientId: clientId!,
    authority: getAuthority(defaultUserFlow),
    knownAuthorities: [authority!],
    redirectUri: '/auth/callback',
    postLogoutRedirectUri: '/logout',
  },
  cache: {
    cacheLocation: 'localStorage',
  },
  system: {
    tokenRenewalOffsetSeconds: 300,
  },
};

export const ApiScopes = [`https://${scopesAuthority}/classifieds-api/Public.Read`];

export const getLoginRequest = (language?: string, platform?: string): RedirectRequest => ({
  scopes: ApiScopes,
  extraQueryParameters: {
    platform: platform || defaultPlatform || '',
    ui_locales: language || getI18n().language || '',
  },
});

// Uses the default (sign-up-or-signin) authority rather than a dedicated password-reset policy:
// forgotPassword=true makes the SignUpOrSignIn_Default user journey jump straight into the same
// PasswordReset sub-journey used by the "Forgot password?" link on the sign-in page, skipping that
// page entirely - see the "Local Account Password Reset" claims provider in TrustFrameworkExtensions.xml.
export const getResetPasswordRequest = (
  email?: string | null,
  language?: string,
  platform?: string
): RedirectRequest => ({
  scopes: ApiScopes,
  extraQueryParameters: {
    forgotPassword: 'true',
    email: email || '',
    platform: platform || defaultPlatform || '',
    ui_locales: language || getI18n().language || '',
  },
});
